var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconVolume = function SvgIconVolume(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5mm",
    height: "6.13mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 14.17 17.39",
    fill: "#717679",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08,17.3s-.06,0-.09,0c-3.82-.05-6.85-3.08-6.9-6.9H.09C.09,7.14,2.32,3.27,5.76.55c.78-.62,1.87-.62,2.65,0,3.44,2.73,5.66,6.59,5.66,9.84-.05,3.83-3.17,6.91-6.99,6.91ZM1.09,10.39c.04,3.27,2.64,5.87,5.91,5.91,3.27.06,6.02-2.61,6.06-5.91,0-2.9-2.12-6.55-5.29-9.05-.41-.33-.99-.33-1.41,0C3.22,3.84,1.1,7.47,1.09,10.39ZM6.62,13.21c-1.55,0-2.82-1.26-2.82-2.82,0-.28.22-.5.5-.5s.5.22.5.5c0,1,.82,1.82,1.82,1.82.28,0,.5.22.5.5s-.22.5-.5.5Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconVolume);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-volume.cf77c760842419806b18b98ed32a3021.svg";